import { Button, Grid, TableContainer } from "@mui/material";
import { DataGridPro } from "@mui/x-data-grid-pro";
import { useAppContext } from "AppContext";
import { SearchNormal1 } from "iconsax-react";
import { useState } from "react";
import { IoFilter } from "react-icons/io5";
import { LuTable2 } from "react-icons/lu";
import {
  MdCheckBox,
  MdCheckBoxOutlineBlank,
  MdExpandLess,
  MdExpandMore,
} from "react-icons/md";
import { theme } from "utils/Theme";
import { CustomLoader, EmptyData, Pagination } from "./DatagridUtils";
import GKCheckbox from "./GKCheckbox";
import GKTextField from "./GKTextField";
import { Show } from "./Show";

const GKTable = (props) => {
  const {
    state: { columnsPersist, commonFilter },
    dispatch,
    apiRef,
  } = useAppContext();

  const {
    rows,
    headerComponent,
    showSearch = true,
    loading,
    ref,
    columnsButton = true,
    CustomPagination,
    exportCsv,
    maxHeight,
    showHeaderGrid = true,
    pinnedColumns,
    // zeroHolding,
    onRowClick,
    height,
    minHeight,
    tableName,
    name,
    headerFilter,
    columns,
  } = props;

  const [isFocused, setIsFocused] = useState(false);

  // const [filterModal, setFilterModal] = useState(false);``

  const [searchText, setSearchText] = useState(commonFilter[name]?.search);

  const CustomToolbar = (prProps) => {
    const { value, onInputChange } = prProps;

    return (
      <Show.When isTrue={showHeaderGrid}>
        <Grid
          container
          justifyContent={"space-between"}
          p={1}
          alignItems={"center"}
          ref={ref}
          borderBottom={`solid 1px ${theme.palette.grey[300]}`}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",

              gap: 10,
              width: "100%",
            }}
          >
            <Grid xs={6}>
              <span
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 4,
                }}
              >
                <Show.When isTrue={showSearch}>
                  <GKTextField
                    style={{ width: 180 }}
                    placeholder="Search"
                    sx={{
                      "& .MuiInputBase-root ": {
                        height: "35px",
                      },
                      "& .MuiOutlinedInput-notchedOutline": {
                        border: "1px solid #E3E8EF",
                      },
                    }}
                    value={value}
                    onChange={onInputChange}
                    type="search"
                    autoFocus={isFocused}
                    onFocus={() => setIsFocused(true)}
                    onBlur={() => setIsFocused(false)}
                    InputProps={{
                      startAdornment: (
                        <SearchNormal1
                          size={22}
                          color={theme.palette.grey[500]}
                        />
                      ),
                    }}
                  />
                </Show.When>
                <Show.When isTrue={tableName}>
                  <Button
                    style={{
                      padding: "6px 10px",
                      color: "#697586",
                      border: "1px solid #E3E8EF",
                    }}
                    onClick={() => {}}
                    startIcon={<IoFilter size={16} />}
                  >
                    Filter
                  </Button>
                </Show.When>
                <Show.When isTrue={exportCsv}>
                  {exportCsv && exportCsv()}
                </Show.When>
                <Show.When isTrue={columnsButton}>
                  <Button
                    onClick={() => {}}
                    style={{
                      padding: "6px 10px",
                      color: "#697586",
                      border: "1px solid #E3E8EF",
                    }}
                    startIcon={<LuTable2 size={16} />}
                  >
                    Columns
                  </Button>
                </Show.When>
              </span>
            </Grid>
            <Grid xs={6} display={"flex"} justifyContent={"flex-end"}>
              <Show.When isTrue={headerComponent}>{headerComponent}</Show.When>{" "}
            </Grid>
          </div>
          {headerFilter && (
            <Grid container display={"flex"} alignItems={"center"} mt={1}>
              {headerFilter}
            </Grid>
          )}
        </Grid>
      </Show.When>
    );
  };

  // useEffect(() => {
  //   const timerId = setTimeout(() => {
  //     dispatch({
  //       type: "FILTER",
  //       data: {
  //         ...commonFilter,
  //         [name]: {
  //           ...commonFilter[name],
  //           search: searchText?.trim(),
  //         },
  //       },
  //     });
  //   }, 400);

  //   return () => {
  //     clearTimeout(timerId);
  //   };
  // }, [searchText]);

  function CheckboxWrapper(props) {
    return (
      <GKCheckbox
        icon={<MdCheckBoxOutlineBlank />}
        checkedIcon={<MdCheckBox />}
        {...props}
      />
    );
  }

  return (
    <TableContainer>
      <DataGridPro
        {...props}
        columnVisibilityModel={columnsPersist && name && columnsPersist[name]}
        apiRef={apiRef}
        getDetailPanelHeight={() => "auto"}
        sortingMode="server"
        filterMode="server"
        keepNonExistentRowsSelected
        disableRowSelectionOnClick
        sortModel={commonFilter[name]?.sortModel}
        loading={loading}
        rows={loading ? [] : rows || []}
        columns={columns?.map((dataItem) => {
          return {
            ...dataItem,
            disableColumnMenu: true,
            disableExport: true,
          };
        })}
        onSortModelChange={(model) => {
          dispatch({
            type: "FILTER",
            data: {
              ...commonFilter,
              [name]: {
                ...commonFilter[name],
                sortModel: model,
              },
            },
          });
        }}
        slotProps={{
          toolbar: {
            value: searchText,
            onInputChange: (event) => {
              setSearchText(event.target.value);
              dispatch({
                type: "FILTER",
                data: {
                  ...commonFilter,
                  [name]: {
                    ...commonFilter[name],
                    search: event.target.value?.trim(),
                    page: 0,
                    skip: 0,
                  },
                },
              });
            },
          },
        }}
        slots={{
          toolbar: CustomToolbar,
          noRowsOverlay: EmptyData,
          loadingOverlay: CustomLoader,
          detailPanelExpandIcon: () => <MdExpandMore size={20} />,
          detailPanelCollapseIcon: () => <MdExpandLess size={20} />,
          footer: CustomPagination || Pagination,
          baseCheckbox: CheckboxWrapper,
        }}
        pinnedColumns={{
          ...pinnedColumns,
          right: ["action"],
        }}
        sx={{
          "& .MuiDataGrid-virtualScroller": {
            maxHeight: maxHeight || "calc(100vh - 256px)",
            minHeight: minHeight || "10px",
          },
          "&.MuiDataGrid-root .MuiTablePagination-root": {
            padding: "0 8px",
          },
          "& .MuiDataGrid-row": {
            "&:hover": {
              cursor: onRowClick ? "pointer" : "",
            },
          },
          minHeight: height,
          maxHeight: height,
        }}
      />

      {/* {filterModal && tableName && (
        <GKCommonTableFilterModal
          isModalOpen={filterModal}
          setIsModalOpen={setFilterModal}
          tableName={tableName}
          name={name}
          zeroHolding={zeroHolding}
        />
      )} */}

      {/* <Show.When isTrue={tableColumnModalOpen}>
        <TableColumnModal
          open={tableColumnModalOpen}
          setOpen={setTableColumnModalOpen}
          columns={columns}
          columnVisibilityModel={columnsPersist}
          dispatch={dispatch}
          name={name}
        />
      </Show.When> */}
    </TableContainer>
  );
};

export default GKTable;
